/* eslint-disable camelcase */
import AnalyticsInterface from './analyticsInterface'
import CartEventWatcher from './CartEventWatcher'

class CartAnalytics extends AnalyticsInterface {
  static EVENTS = {
    REMOVE_FROM_CART: 'remove_from_cart',
    ADD_TO_CART: 'add_to_cart',
    CART_LOADED: 'cart-loaded'
  }

  static DEFAULT_CURRENCY = 'AUD'

  constructor(ga4) {
    super(ga4)
    this.cartEventWatcher = new CartEventWatcher(this)
  }

  cartChange(type, products) {
    if (!products?.length) return

    const currency = products[0]?.currency || CartAnalytics.DEFAULT_CURRENCY
    const value = this.calculateTotalValue(products)
    const cartEvent = type === 'add' ? CartAnalytics.EVENTS.ADD_TO_CART : CartAnalytics.EVENTS.REMOVE_FROM_CART
    this.track(cartEvent, {
      currency,
      value,
      items: this.formatProductsForTracking(products),
      raw_items: products
    })
  }

  initialCart(cart) {
    if (!cart) return
    this.track(CartAnalytics.EVENTS.CART_LOADED, { cart })
  }

  calculateTotalValue(products) {
    return products.reduce((total, p) => total + p.presentment_price * p.quantity, 0)
  }

  extractIDFromSku(sku) {
    return sku.split('_').slice(0, 2).join('_') || sku
  }

  formatProductsForTracking(products) {
    // eslint-disable-next-line camelcase
    return products.map(
      ({
        sku,
        title,
        quantity,
        presentment_price,
        currency = CartAnalytics.DEFAULT_CURRENCY,
        additionalData = {}
      }) => ({
        item_id: this.extractIDFromSku(sku),
        item_name: title,
        price: presentment_price,
        quantity,
        currency,
        ...additionalData
      })
    )
  }
}

export default CartAnalytics
